export default __webpack_public_path__ + "static/media/Rootsgoods.f006cb28.png";